<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  totalQuestions: number;
  completedQuestions: number;
};

const props = defineProps<Props>();

const questions = computed(() => {
  return Array.from({ length: props.totalQuestions }, (_, index) => ({
    index,
    isCompleted: index < props.completedQuestions,
  }));
});
</script>

<template>
  <div class="d-flex justify-space-evenly gr-2 flex-column rounded">
    <div
      v-for="question in questions"
      :key="question.index"
      class="progress-bar rounded-sm"
      :class="{ 'progress-bar--completed': question.isCompleted }"
    />
  </div>
</template>

<style lang="scss" scoped>
.progress-bar {
  width: 8px;
  height: 100%;
  max-height: 150px;
  min-height: 20px;
  background-color: rgba(255, 255, 255, 0.3);
  transition: background-color 0.3s ease;

  &--completed {
    background-color: rgba(255, 255, 255, 0.9);
  }
}
</style>
